import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import includes from "lodash/includes";
import { useEffect, useState } from "react";

const StyledSelect = styled(Select)({
    fontSize: "14px",
    padding: "9px 6px 9px 6px",
    boxSizing: "border-box",
    height: "37px",
    width: "100%",
    "&:focus": {
        backgroundColor: "transparent",
        borderBottom: "none",
    },
    "&::before": {
        borderBottom: "none !important",
    },
    "&::after": {
        borderBottom: "none !important",
    },
});

const AdminDocumentTypeList = (props) => {
    const {
        documentTypesEnumList,
        documentTypesForParentEntity,
        formDisabled,
        mediaAssetKey,
        optionalDocs,
        options,
        parentEntityTypeKey,
        parentTypeKey,
        preexistingValue,
        requiredDocs,
        role,
        savedDocuments,
        style,
        updateDocumentFromAdminList,
        voucherStatus,
    } = props;

    const [selectedValue, setSelectedValue] = useState("Select");

    useEffect(() => {
        if (preexistingValue["documentType"]) {
            setSelectedValue(preexistingValue["documentType"]["name"]);
        } else {
            setSelectedValue("Select");
        }
    }, [preexistingValue]);

    const updateSelectedValue = () => {
        if (preexistingValue["documentType"]) {
            if (preexistingValue["documentType"]["name"] !== selectedValue) {
                setSelectedValue(preexistingValue["documentType"]["name"]);
            }
        } else if (selectedValue !== "Select") {
            setSelectedValue("Select");
        }
    };

    const handleValueSelect = (e) => {
        documentTypesForParentEntity.forEach((documentTypeObject) => {
            if (e.target.value.toLowerCase() === documentTypeObject.name.toLowerCase()) {
                for (const key in documentTypesEnumList) {
                    if (documentTypeObject.name.toLowerCase() === documentTypesEnumList[key]["display"].toLowerCase()) {
                        updateDocumentFromAdminList(
                            mediaAssetKey,
                            key,
                            parentEntityTypeKey,
                            documentTypeObject.documentTypeKey,
                            documentTypeObject
                        );

                        setSelectedValue(e.target.value);

                        return;
                    }
                }
                updateDocumentFromAdminList(
                    mediaAssetKey,
                    "OTHER",
                    parentTypeKey,
                    documentTypeObject.documentTypeKey,
                    documentTypeObject
                );
            }
        });
        setSelectedValue(e.target.value);
    };

    const shouldAllowMoreDocumentsOfSameType = (documentType) => {
        const documentNames = Object.values(savedDocuments).map((mediaAsset) =>
            mediaAsset.documentType ? mediaAsset.documentType.name.toLowerCase() : null
        );
        return documentType.multipleAllowed || !documentNames.includes(documentType.name.toLowerCase());
    };

    const isFormDisabled = () => {
        const mediaAsset = preexistingValue;
        const voucherAwaitingPayment = voucherStatus === "Awaiting Payment";
        const voucherReadyForAccounting = voucherStatus === "Ready For Accounting";

        if (
            voucherAwaitingPayment &&
            role === "broker" &&
            includes(["OTHER", "COMMISSION_PAYMENT"], mediaAsset["mediaAssetType"])
        ) {
            return options
                ? !includes(options.canView, mediaAsset["mediaAssetType"]) && mediaAsset["updated"] === true
                : formDisabled;
        }
        return (voucherAwaitingPayment || voucherReadyForAccounting) && role === "broker"
            ? true
            : options && formDisabled
            ? !(includes(options.canUpload, mediaAsset["mediaAssetType"]) && mediaAsset["updated"] !== true)
            : formDisabled;
    };

    const renderMenuItem = (documentType, index) => {
        return shouldAllowMoreDocumentsOfSameType(documentType) ? (
            <MenuItem key={index} value={documentType.name}>
                {documentType.name}
            </MenuItem>
        ) : (
            <MenuItem key={index} value={documentType.name} style={{ display: "none" }}>
                {documentType.name}
            </MenuItem>
        );
    };

    updateSelectedValue();

    return (
        <StyledSelect
            name="document-admin-dropdown"
            value={selectedValue}
            onChange={(e) => handleValueSelect(e)}
            style={style}
            disabled={isFormDisabled()}
        >
            <MenuItem value="Select" disabled>
                Select
            </MenuItem>
            <MenuItem value="" disabled>
                Required
            </MenuItem>
            {requiredDocs.map((documentReq, indexReq) => {
                return renderMenuItem(documentReq, indexReq);
            })}

            <MenuItem value="" disabled>
                Optional
            </MenuItem>
            {optionalDocs.map((documentOpt, indexOpt) => {
                return renderMenuItem(documentOpt, indexOpt);
            })}
        </StyledSelect>
    );
};

export default AdminDocumentTypeList;
